<template>
  <v-container class="mb-4" v-if="deno">
    <v-row class="justify-center">
      <h2 v-if="deno && deno.denoPrincipale">
        Dénomination commune correspondante: {{ deno.denoPrincipale }}
      </h2>
    </v-row>
    <v-row justify="space-around">
      <v-card class="deno" id="ficheDC" style="min-width: 100%">
        <v-card-title class="justify-center white--text">{{
          deno.denoPrincipale || deno.libelle
        }}</v-card-title>
        <v-card-subtitle class="white--text">
          <p v-if="deno.dateMaj" class="text-right">
            <v-icon color="white">mdi-calendar-sync</v-icon>&nbsp;{{
              deno.dateMaj | shortDateFr
            }}
          </p>
          <p
            v-if="deno.definition"
            style="font-size: 1.3em; font-weight: 500; letter-spacing: 0.06em"
          >
            {{ deno.definition }}
          </p>
        </v-card-subtitle>

        <v-expansion-panels
          v-model="panels"
          flat
          tile
          accordion
          multiple
          class="white--text"
        >
          <!-- Typologie-->
          <v-expansion-panel>
            <v-expansion-panel-header color="deno" class="white--text">
              <v-row>
                <v-col>
                  <h3>Typologie</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4" md="2" xl="1" class="deno white--text"
                  >&nbsp;</v-col
                >
                <v-col class="denolighten5">
                  <p>{{ deno.typologie }}&nbsp;</p>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Equivalences -->
          <v-expansion-panel>
            <v-expansion-panel-header color="deno" class="white--text">
              <v-row>
                <v-col>
                  <h3>Equivalences</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4" md="2" xl="1" class="deno white--text"
                  >&nbsp;</v-col
                >
                <v-col class="denolighten5">
                  <ul>
                    <li v-for="eqv in equivalences" :key="eqv.id">
                      {{ eqv.libelle }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Domaines -->
          <v-expansion-panel>
            <v-expansion-panel-header color="deno" class="white--text">
              <v-row>
                <v-col>
                  <h3>Domaines</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4" md="2" xl="1" class="deno white--text"
                  >&nbsp;</v-col
                >
                <v-col class="denolighten5">
                  <ul>
                    <li v-for="dom in domaines" :key="dom.id">
                      {{ dom.libelle }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Contrôles -->
          <v-expansion-panel>
            <v-expansion-panel-header color="deno" class="white--text">
              <v-row>
                <v-col>
                  <h3>Contrôles</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4" md="2" xl="1" class="deno white--text"
                  >&nbsp;</v-col
                >
                <v-col class="denolighten5">
                  <ul>
                    <li v-for="ctr in controles" :key="ctr.libelle">
                      {{ ctr.intitule }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Evaluations -->
          <v-expansion-panel>
            <v-expansion-panel-header color="deno" class="deno white--text">
              <v-row>
                <v-col>
                  <h3>Evaluations</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4" md="2" xl="1" class="deno white--text"
                  >&nbsp;</v-col
                >
                <v-col class="denolighten5">
                  <ul>
                    <li v-for="ev in evaluations" :key="ev.libelle">
                      {{ ev.intitule }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Normes -->
          <v-expansion-panel>
            <v-expansion-panel-header color="deno" class="deno white--text">
              <v-row>
                <v-col>
                  <h3>Normes</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4" md="2" xl="1" class="deno white--text"
                  >&nbsp;</v-col
                >
                <v-col class="denolighten5">
                  <ul>
                    <li v-for="norme in normes" :key="norme.libelle">
                      <v-dialog max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{ norme.intitule }}
                          </span>
                        </template>

                        <v-card>
                          <v-card-title
                            class="text-h5 denolighten3 white--text"
                          >
                            Norme {{ norme.intitule }}
                          </v-card-title>

                          <v-card-text class="denolighten5">
                            {{ norme.texte }}
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Bibliographies -->
          <v-expansion-panel v-if="bibliographies.length > 0">
            <v-expansion-panel-header color="deno" class="deno white--text">
              <v-row>
                <v-col>
                  <h3>Bibliographies</h3>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4" md="2" xl="1" class="deno white--text"
                  >&nbsp;</v-col
                >
                <v-col class="denolighten5">
                  <ul>
                    <li v-for="bib in bibliographies" :key="bib.libelle">
                      {{ bib.intitule }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-row>
    <v-row justify="space-between" class="mt-6">
      <v-col md="4">
        <v-btn color="deno" class="white--text" @click="editeFicheEvaluation">
          <v-icon color="white">mdi-printer</v-icon>&nbsp; Edition de la fiche
          d'évaluation
        </v-btn>
      </v-col>
      <v-col md="4" class="text-right">
        <v-btn
          color="deno"
          class="white--text"
          :to="{ name: 'produits-deno-commune', params: { id } }"
        >
          Liste des produits &nbsp;<v-icon color="white"
            >mdi-medical-bag</v-icon
          >
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <app-pdf-generator
        v-if="deno && evaluations"
        ref="appPdfGen"
        :filename="`evaluation ${deno.libelle}`"
        :deno="deno"
        :evaluations="evaluations"
      ></app-pdf-generator>
    </v-row>
  </v-container>
</template>

<script>
import denominationService from "@/services/DenominationsService";
import AppPdfGenerator from "@/components/AppPdfGenerator";

export default {
  name: "DenoView",
  components: {
    AppPdfGenerator,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      deno: null,
      bibliographies: "",
      controles: "",
      evaluations: "",
      normes: "",
      equivalences: "",
      domaines: "",
      dialog: false,
      panels: [0, 1, 2, 3, 4, 5],
    };
  },
  methods: {
    editeFicheEvaluation() {
      this.$refs.appPdfGen.downloadPdf();
    },
  },
  created() {
    // Obtient les données à afficher

    let denoDemandee = null;
    denominationService
      .getDenomination(this.id)
      .then((res) => {
        denoDemandee = res.data;
        let id =
          denoDemandee.idDenoPrincipale && denoDemandee.idDenoPrincipale != 0
            ? denoDemandee.idDenoPrincipale
            : this.id;
        if (id != denoDemandee.id) {
          denominationService
            .getDenomination(this.id)
            .then((res) => {
              this.deno = res.data;
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.deno = denoDemandee;
        }
        Promise.all([
          denominationService.getBibliographies(id),
          denominationService.getControles(id),
          denominationService.getEvaluations(id),
          denominationService.getNormes(id),
          denominationService.getEquivalences(id),
          denominationService.getDomaines(id),
        ]).then((res) => {
          this.bibliographies = res[0].data;
          this.controles = res[1].data;
          this.evaluations = res[2].data;
          this.normes = res[3].data;
          this.equivalences = res[4].data;
          this.domaines = res[5].data;
        });

        this.$store.dispatch("fetchResultats", {
          type: 1,
          recherche: denoDemandee.libelle,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style scoped>
h2 {
  font-size: 1em;
  text-align: center;
  color: var(--v-deno-darken4);
  font-weight: bold;
  margin-bottom: 1em;
}
.v-card {
  font-size: 0.9em;
}
#ficheDC >>> .v-expansion-panel-header__icon > .v-icon {
  color: #fff;
}

#ficheDC >>> .v-expansion-panel-content__wrap {
  padding: 0 12px;
}

h3 {
  font-size: 1.05em;
}

li {
  list-style: none;
}
</style>
